<template>
  <BaseDialog
    v-model="showDialog"
    dialogIcon="mdi-account-cancel"
    title="Aktiver bruker"
  >
    <template v-slot>
      <p>
        Under er en liste med deaktiverte brukere som kan bli aktivert igjen
      </p>

      <span v-if="contactPersons && contactPersons.length > 0">
        <v-list
          class="py-0"
          v-for="(contactPerson, index) in contactPersons"
          :key="index + 'contactPerson'"
          color="cardSurface"
        >
          <v-divider v-if="index !== 0"></v-divider>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>
                {{ contactPerson.person.fullName }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ contactPerson.person.email }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-1"
                    icon
                    dark
                    small
                    color="primary"
                    @click="activateContactPerson(contactPerson)"
                  >
                    <v-icon v-bind="attrs" v-on="on" dark>
                      mdi-account-reactivate
                    </v-icon>
                  </v-btn>
                </template>
                <span>Aktiver bruker</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <!-- <v-divider></v-divider> -->
      </span>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  name: "EditProfileDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Array,
    },
  },
  methods: {
    async activateContactPerson(contactPerson) {
      this.$emit("activateContactPerson", contactPerson);
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    contactPersons(): Array<any> {
      return this.data;
    },
  },

  components: {
    BaseDialog,
  },
});
</script>
